import { isNil, omitBy } from 'lodash-es';

export function omitNil<T extends object>(
  value: T | null | undefined,
): Partial<T> {
  return omitBy<T>(value, isNil);
}
